import {
  storyblokEditable,
  renderRichText,
  StoryblokComponent,
} from "@storyblok/react"
import { Button } from "../../ui/button"
import { motion } from "framer-motion"

export default function ValueProps({ blok }: any) {
  const toPlain = (rich: any) =>
    (renderRichText(rich || { content: [] }) || "")
      .toString()
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim()

  const ctaText = toPlain(blok?.ctaText) || ""

  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <span className="mt-3 block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF]" />
        </div>

        <div
          className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 leading-relaxed mb-12 max-w-3xl"
          dangerouslySetInnerHTML={{
            __html: renderRichText(blok.intro || { content: [] }) || "",
          }}
        />

        <motion.div
          className="grid md:grid-cols-2 gap-8"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            hidden: {},
            show: {
              transition: { staggerChildren: 0.08, delayChildren: 0.05 },
            },
          }}
        >
          {blok.items?.map((nestedBlok: any) => (
            <motion.div
              key={nestedBlok._uid}
              variants={{
                hidden: { opacity: 0, y: 10, filter: "blur(2px)" },
                show: {
                  opacity: 1,
                  y: 0,
                  filter: "blur(0px)",
                  transition: { duration: 0.45, ease: "easeOut" },
                },
              }}
              className="rounded-2xl border border-gray-100 bg-white/80 shadow-[0_1px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_10px_28px_rgba(27,31,59,0.10)] transition-shadow p-6"
            >
              <StoryblokComponent blok={nestedBlok} />
            </motion.div>
          ))}
        </motion.div>

        {ctaText && (
          <div className="mt-12 text-center">
            <Button asChild variant="default" size="lg">
              <a
                href={blok?.ctaLink?.url || blok?.ctaLink?.cached_url || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaText}
              </a>
            </Button>
          </div>
        )}
      </div>
    </section>
  )
}
